module.exports = __webpack_public_path__ + "static/media/icon-plus-tiffany.996fe536.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-plus-tiffany.svg
// module id = 114
// module chunks = 0